import { render } from "./AssistantDialog.vue?vue&type=template&id=66dd7ae0&scoped=true"
import script from "./AssistantDialog.vue?vue&type=script&lang=js"
export * from "./AssistantDialog.vue?vue&type=script&lang=js"

import "./AssistantDialog.vue?vue&type=style&index=0&id=66dd7ae0&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dd7ae0"]])

export default __exports__